const extractVideoIdFromUrl = (url?: string): string | null => {
  if (!url) return null;
  // Extract youtube id from youtube URL
  const youtubeRegex = /[?&]v=([^&]+)/;
  const match = youtubeRegex.exec(url);
  return match ? match[1] : null;
};

export default extractVideoIdFromUrl;
